import { render, staticRenderFns } from "./ViTeacherAcademicManagementFilter.vue?vue&type=template&id=3fa016aa"
import script from "./ViTeacherAcademicManagementFilter.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports